import Swal from 'sweetalert2'

const POLL_INTERVAL = 10000;
const POLL_IDLE_INTERVAL = 30000;
const POLL_JITTER = 3000;
const POLL_BACKOFF = [20000, 30000];

const hoaModule = {
    isLoading: false,
    currentIndex: 0,
    pollTimer: null,
    pollFailures: 0,
    init() {
        let _this = this;

        // $(document).on('click', '.hoa-meeting-vote-get-code-btn', this, this.getCode);
        // $(document).on('click', '.hoa-meeting-vote-login-btn', this, this.login);
        // $(document).on('click', '.hoa-poll-send-data', this, this.send);
        $(document).on('click', '.hoa-poll-vote-question', this, this.send);
        $(document).on('click', '#hoa_representative', function() {
            if ($('#hoa_representative').is(':checked')) {
                $('.hoa-representative-container').show();
            } else {
                $('.hoa-representative-container').hide();
            }
        });

        _this.schedulePoll(POLL_INTERVAL);

        // $(document).on('click', '.hoa-poll-next-question', function() {
        //     console.log(_this.currentIndex);
        //     console.log(pollQuestions.length);
        //     if (_this.currentIndex < pollQuestions.length - 1) {
        //         _this.currentIndex++;
        //         _this.showQuestion(_this.currentIndex);
        //     }
        // });
        // $(document).on('click', '.hoa-poll-prev-question', function() {
        //     if (_this.currentIndex > 0) {
        //         _this.currentIndex--;
        //         _this.showQuestion(_this.currentIndex);
        //     }
        // });
    },
    // Next refresh after `delay` ms plus a random jitter, so dozens of open tabs do not hit the server in lockstep
    schedulePoll(delay) {
        let _this = this;
        clearTimeout(_this.pollTimer);
        _this.pollTimer = setTimeout(function() {
            if (document.visibilityState !== 'visible') {
                _this.schedulePoll(POLL_INTERVAL);
                return;
            }
            _this.refreshPollDataFromAPI();
        }, delay + Math.floor(Math.random() * POLL_JITTER));
    },
    refreshPollDataFromAPI() {
        let _this = this;

        var values='';
        values+='id=' + encodeURIComponent($('.hoa-vote-container').data('id'));
        values+='&token=' + encodeURIComponent($('.hoa-vote-container').data('token'));
        values+='&_token=' + encodeURIComponent($('meta[name="csrf-token"]').attr("content"));
        $.ajax({
            type: "POST",
            url: baseURL + '/hoa/general-meeting/get-data',
            data: values,
            success: function(response) {

                if (response.status == 1) {
                    _this.pollFailures = 0;
                    $('.hoa-reconnecting').remove();

                    if (response.data.question_id != $('.hoa-vote-container').data('question-id')) {
                        $('.hoa-vote-container').html(response.view);
                        $('.hoa-vote-container').data('question-id', response.data.question_id);
                    }
                    if (response.data.all_questions_answered) {
                        $('.hoa-vote-container').html(response.view);
                    }

                    // once every question is closed only a late addition to the agenda can change the page
                    _this.schedulePoll(response.data.all_questions_answered ? POLL_IDLE_INTERVAL : POLL_INTERVAL);
                    return true;
                }

                _this.pollFailed();
            },
            error(error) {
                _this.pollFailed();
            },
        });
    },
    // Back off while the server is struggling instead of adding to its load, and let the voter know
    pollFailed() {
        this.pollFailures++;
        if (!$('.hoa-reconnecting').length) {
            $('.hoa-vote-container').before('<div class="hoa-reconnecting text-center small text-secondary mb-3">Se reconectează...</div>');
        }
        this.schedulePoll(POLL_BACKOFF[Math.min(this.pollFailures, POLL_BACKOFF.length) - 1]);
    },
    // showQuestion(index) {
    //     var questionId = pollQuestions[index];
    //     $('.hoa-poll-question-text').hide();
    //     $('#hoa-poll-question-text-' + questionId).show();

    //     $('.hoa-poll-question').hide();
    //     $('#hoa-poll-question-' + questionId).show();

    //     $('.hoa-poll-prev-question').attr('disabled', true);
    //     if (index > 0) {
    //         $('.hoa-poll-prev-question').attr('disabled', false);
    //     }

    //     if (index == pollQuestions.length - 1) {
    //         $('.hoa-poll-next-question').hide();
    //         $('.hoa-poll-send-data').show();
    //     } else {
    //         $('.hoa-poll-next-question').show();
    //         $('.hoa-poll-send-data').hide();
    //     }
    // },
    send(event) {
        const _this = event.data;
        event.preventDefault();
        let id = $(this).data('id');
        let questionId = $(this).data('question-id');
        let pollId = $(this).data('poll-id');

        if (_this.isLoading) {
            return false;
        }

        var vote = $('input[name="hoa_poll_question"]:checked').val();
        if (!vote) {
            Swal.fire({
                text: 'Te rugăm să selectezi o opțiune înainte de a trimite votul!'
            });
            return false;
        }

        //Loading...
        _this.isLoading = true;
        let element = this;
        $(element).find('i').show();

        var values='';
        values+='id=' + encodeURIComponent(id);
        values+='&poll_id=' + encodeURIComponent(pollId);
        values+='&question_id=' + encodeURIComponent(questionId);
        values+='&vote=' + encodeURIComponent(vote);
        values+='&token=' + encodeURIComponent($(this).data('token'));
        values+='&_token=' + encodeURIComponent($('meta[name="csrf-token"]').attr("content"));
        $.ajax({
            type: "POST",
            url: baseURL + '/hoa/general-meeting/vote/save',
            data: values,
            success: function(response) {
                _this.isLoading = false;
                $(element).find('i').hide();

                if (response.status == 1) {
    
                    $('.hoa-vote-container').html(response.view);

                    return true;
                }

                Swal.fire({
                    text: response.message
                });
            },
            error(error) {
                _this.isLoading = false;
                $(element).find('i').hide();
            },
        });
    },
    login(event) {
        const _this = event.data;
        event.preventDefault();
        let id = $(this).data('id');

        if (_this.isLoading) {
            return false;
        }

        var errors = false;
        if ($('#hoa_owner option:selected').val() == '') {
            errors = true;
            $('#hoa_owner').addClass('is-invalid');
        }
        if ($('#hoa_email').val() == '') {
            errors = true;
            $('#hoa_email').addClass('is-invalid');
        }
        if ($('#hoa_code').val() == '') {
            errors = true;
            $('#hoa_code').addClass('is-invalid');
        }
        if ($('#hoa_representative').is(':checked')) {
            if ($('#hoa_representative_name').val() == '') {
                errors = true;
                $('#hoa_representative_name').addClass('is-invalid');
            }
        }
        if (errors) {
            Swal.fire({
                text: 'Va rugam completati toate campurile obligatorii!'
            });
            return false;
        }

        //Loading...
        _this.isLoading = true;
        let element = this;
        $(element).find('i').show();

        var values='';
        values+='id=' + encodeURIComponent(id);
        values+='&_token=' + encodeURIComponent($('meta[name="csrf-token"]').attr("content"));
        values+='&owner=' + encodeURIComponent($('#hoa_owner option:selected').val());
        values+='&email=' + encodeURIComponent($('#hoa_email').val());
        values+='&representative=' + encodeURIComponent(($('#hoa_representative').is(':checked') ? 1 : 0));
        values+='&representative_name=' + encodeURIComponent($('#hoa_representative_name').val());
        values+='&code=' + encodeURIComponent($('#hoa_code').val());
        $.ajax({
            type: "POST",
            url: baseURL + '/hoa/general-meeting/vote/login',
            data: values,
            success: function(response) {
                _this.isLoading = false;
                $(element).find('i').hide();

                if (response.status == 0) {
                    var errorHtml = '';
                    for(var errorKey in response.errors) {
                        if(!response.errors.hasOwnProperty(errorKey)) continue;
                        for(var error in response.errors[errorKey]) {
                            $("#hoa_"+errorKey).addClass('is-invalid');
                            errorHtml += response.errors[errorKey][error] + '<br>';
                        }
                    }

                    Swal.fire({
                        html: response.message
                    });

                    return false;
                }

                if (response.status == 1) {
    
                    window.location = response.data.redirect_url

                    return true;
                }

                Swal.fire({
                    text: response.message
                });
            },
            error(error) {
                _this.isLoading = false;
                $(element).find('i').hide();
            },
        });
    },
    getCode(event) {
        const _this = event.data;
        event.preventDefault();
        let id = $(this).data('id');

        if (_this.isLoading) {
            return false;
        }

        var errors = false;
        if ($('#hoa_owner option:selected').val() == '') {
            errors = true;
            $('#hoa_owner').addClass('is-invalid');
        }
        if ($('#hoa_email').val() == '') {
            errors = true;
            $('#hoa_email').addClass('is-invalid');
        }
        if ($('#hoa_representative').is(':checked')) {
            if ($('#hoa_representative_name').val() == '') {
                errors = true;
                $('#hoa_representative_name').addClass('is-invalid');
            }
        }
        if (errors) {
            Swal.fire({
                text: 'Va rugam completati toate campurile obligatorii!'
            });
            return false;
        }

        //Loading...
        _this.isLoading = true;
        let element = this;
        $(element).find('i').show();

        var values='';
        values+='id=' + encodeURIComponent(id);
        values+='&_token=' + encodeURIComponent($('meta[name="csrf-token"]').attr("content"));
        values+='&owner=' + encodeURIComponent($('#hoa_owner option:selected').val());
        values+='&email=' + encodeURIComponent($('#hoa_email').val());
        values+='&representative=' + encodeURIComponent(($('#hoa_representative').is(':checked') ? 1 : 0));
        values+='&representative_name=' + encodeURIComponent($('#hoa_representative_name').val());
        $.ajax({
            type: "POST",
            url: baseURL + '/hoa/general-meeting/vote/get-pin-code',
            data: values,
            success: function(response) {
                _this.isLoading = false;
                $(element).find('i').hide();

                if (response.status == 0) {
                    var errorHtml = '';
                    for(var errorKey in response.errors) {
                        if(!response.errors.hasOwnProperty(errorKey)) continue;
                        for(var error in response.errors[errorKey]) {
                            $("#hoa_"+errorKey).addClass('is-invalid');
                            errorHtml += response.errors[errorKey][error] + '<br>';
                        }
                    }

                    Swal.fire({
                        html: response.message
                    });

                    return false;
                }

                if (response.status == 1) {
    
                    $('.hoa-code-container').show();
                    $(element).hide();
                    $('.hoa-meeting-vote-login-btn').show();

                    Swal.fire({
                        html: response.message
                    });

                    return true;
                }

                Swal.fire({
                    text: response.message
                });
            },
            error(error) {
                _this.isLoading = false;
                $(element).find('i').hide();
            },
        });
    },
};

$(document).ready(function() {
    if ($('.hoa-module').length) {
        hoaModule.init();
    }
});